export const listData = store => (store ? store.list : { data: [] });
